export default {
  brand: '品牌后台',
  dashboard: '数据看板',
  products: '产品管理',
  antiFake: '防伪管理',
  scanTemplate: '扫码模板',
  scanTemplateEditor: '模板编辑器',
  supplyChain: '供应链管理',
  production: '生产管理',
  members: '会员管理',
  memberList: '会员列表',
  memberDetail: '会员详情',
  memberLevelPrivilege: '会员等级特权',
  memberDecoration: '会员装修',
  blacklistManagement: '黑名单管理',
  memberManagement: '会员管理',
  memberBasicConfig: '基础设置',
  points: '积分',
  pointsIssueDetail: '发放明细',
  pointsIssueStats: '发放统计',
  pointsConfig: '积分配置',
  marketing: '营销活动',
  activityManagement: '活动管理',
  activityList: '活动列表',
  activityAdd: '创建活动',
  activityEdit: '编辑活动',
  activityDetail: '活动详情',
  drawRecord: '开奖记录',
  giftClaimRecord: '礼品领取记录',
  activityTemplate: '活动模板',
  marketingData: '营销数据',
  mall: '积分商城配置',
  pointsMall: '积分商城',
  pointsProduct: '积分商品',
  pointsProductAddEdit: '添加/编辑礼品',
  pointsProductCategory: '商品分类',
  exchangeRecord: '兑换记录',
  mallDecoration: '商城装修',
  exchangeStats: '兑换统计',
  dealers: '经销商管理',
  settings: '品牌设置',
  reports: '数据报表',
  code: '防伪码管理',
  codeManagement: '码管理',
  codeBatchList: '码批次列表',
  codeStatusControl: '码状态控制',
  antiFakeTrace: '防伪溯源',
  productLinkTemplate: '产品关联模板',
  scanDetail: '扫码明细',
  alertRecord: '预警记录',
  alertSetting: '预警设置',
  productCodeAssignment: '产品赋码',
  merchants: '商户管理',
  companyInfo: '企业信息',
  emailConfig: '邮箱配置',
  smsConfig: '短信配置',
  i18nManagement: '多语言管理',
  paymentAuthConfig: '支付与授权配置',
  systemSettings: '系统设置',
  roleManagement: '角色管理',
  accountManagement: '账号管理',
  operationLog: '操作日志',
  afterSaleFeedback: '售后反馈',
  productLibrary: '产品库',
  productList: '产品列表',
  productAdd: '添加产品',
  productEdit: '编辑产品',
  productCategory: '产品分类',
  productAttribute: '产品属性',
  giftLibrary: '礼品库',
  giftList: '礼品列表',
  giftAdd: '添加礼品',
  giftEdit: '编辑礼品',
  giftCategory: '礼品分类',
  productionInfo: '生产信息',
  productionBatch: '生产批次',
  batchAdd: '添加生产批次',
  batchEdit: '编辑生产批次',
  factoryManagement: '工厂管理',
  materialLibrary: '素材库',
  memberLevelAdd: '添加会员等级',
  memberLevelEdit: '编辑会员等级',
};
